import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon'
import clsx from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'

import { getRandomColorById } from '../../../utils/colors'
import type { StaticField } from '../../Views/types'
import { getLinkToUrl } from '../utils'

interface Props {
  field: StaticField
  post: Post
  highlighted: boolean
  mediaUrl: string
  aspectRatio: StaticField['settings']['aspectRatio']
  linkTo: string
  preview: boolean
  isSinglePost: boolean
}
export const CardBanner = ({
  field,
  post,
  highlighted,
  mediaUrl,
  aspectRatio,
  linkTo,
  preview,
  isSinglePost,
}: Props) => {
  const { Link } = useRouter()

  if (!mediaUrl && !preview) {
    return null
  }

  const { default: defaultUrl } = field
  const fieldMediaUrl = mediaUrl || (preview ? defaultUrl : '')

  const linkToUrl = getLinkToUrl({ linkTo, post })

  if (isSinglePost) {
    return (
      <div
        className={clsx(
          'w-full relative',
          aspectRatio || 'aspect-video',
          highlighted && 'border-2 border-focused',
        )}
      >
        <div
          className="w-full h-full flex justify-center items-center"
          style={{ backgroundColor: getRandomColorById(post?.id ?? '') }}
        >
          <DocumentTextIcon className="w-16 h-16 text-white" />
        </div>
        <div
          className="w-full h-full bg-cover bg-center absolute top-0 start-0"
          style={{ backgroundImage: `url(${fieldMediaUrl})` }}
        ></div>
      </div>
    )
  }

  return (
    <Link href={linkToUrl} variant="inherit" tabIndex={-1}>
      <div
        className={clsx(
          'w-full relative',
          aspectRatio || 'aspect-video',
          highlighted && 'border-2 border-focused',
        )}
      >
        <div
          className="w-full h-full flex justify-center items-center"
          style={{ backgroundColor: getRandomColorById(post?.id ?? '') }}
        >
          <DocumentTextIcon className="w-16 h-16 text-white" />
        </div>
        <div
          className="w-full h-full bg-cover bg-center absolute top-0 start-0"
          style={{ backgroundImage: `url(${fieldMediaUrl})` }}
        ></div>
      </div>
    </Link>
  )
}
